export function getComplianceColor(value: number): string {
  if (value < 60) return '#ff4d4f';
  if (value < 85) return '#faad14';
  return '#00BFB3';
}

export type CheckinStatusKey = 'on_time' | 'late' | 'absent' | 'pending';

export const CHECKIN_STATUS_COLORS: Record<
  CheckinStatusKey,
  { bg: string; text: string; bar: string }
> = {
  on_time: { bg: '#d9f7be', text: '#389e0d', bar: '#52c41a' },
  late: { bg: '#fff7e6', text: '#d46b08', bar: '#faad14' },
  absent: { bg: '#fff1f0', text: '#cf1322', bar: '#ff4d4f' },
  pending: { bg: '#f0f0f0', text: '#8c8c8c', bar: '#d9d9d9' },
};
